module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Network Quality":"Network Quality"},"zh":{"Network Quality":"网络质量"}}')
  delete Component.options._Ctor
}
